import { createSlice } from '@reduxjs/toolkit'

const registerClubSlice = createSlice({
    name: 'register-club',
    initialState: {},
    reducers: {
        registerClub() {},
    },
})

const { actions, reducer } = registerClubSlice

export const { registerClub } = actions

export default reducer
